import { Directive, HostBinding, Input } from '@angular/core';
import { environment } from '@env/environment';

@Directive({
  selector: 'img[assets]',
  standalone: false,
})
export class AssetsDirective {
  @HostBinding('src')
  get src(): string {
    return `assets/${environment.theme}/${this._filename}`;
  }

  private _filename = '';

  @Input()
  set assets(filename: string) {
    this._filename = filename;
  }
}
